import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-alternate-address",
  templateUrl: "./alternate-address.component.html",
  styleUrls: ["./alternate-address.component.scss"]
})
export class AlternateAddressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
